<template>
  <v-card-text class="pt-0">
    <div class="force-validation">
      <div class="force-validation__wrapper">
        <span v-for="(total, i) in validationsCountTotal" :key="total.id" :class="['force-validation', validationsCount > i && 'active']"></span>
      </div>

      <p
        :class="[
          'force-validation__messages',
          validationsStatus.length && validationsStatus.find(i => i.id === item.id).valid
            ? 'force-validation__message--success'
            : 'force-validation__message--error'
        ]"
        v-for="(item, i) in passwordValidations"
        :key="`message${i}`"
      >
        <v-icon v-if="validationsStatus.length && validationsStatus.find(i => i.id === item.id).valid" color="success">done</v-icon>

        <v-icon v-if="validationsStatus.length && !validationsStatus.find(i => i.id === item.id).valid" color="error">close</v-icon>

        <v-icon v-if="!validationsStatus.length" color="error">close</v-icon>
        {{ item.message }}
      </p>
    </div>
  </v-card-text>
</template>

<script>
import { getRulesPassword } from '@/services/authentication';

import {
  minimumPasswordSize,
  quantityUppercasePassword,
  quantityNumbersPassword,
  notContainLoginInPassword,
  validationCaseSensitive,
  requireCharacterSpecial,
  forbidThreeNumbersSequential,
  quantityCharactersAlpha,
  quantityPasswordsDoNotRepeat
} from '@/helpers/validations/auth';

export default {
  props: {
    stringValue: { type: String, default: '' }
  },

  data: () => ({
    validationsCount: 0,
    validationsCountTotal: 0,
    validationsStatus: [],
    passwordValidations: [],
    MinimumPasswordSize: minimumPasswordSize,
    QuantityUppercasePassword: quantityUppercasePassword,
    QuantityNumbersPassword: quantityNumbersPassword,
    NotContainLoginInPassword: notContainLoginInPassword,
    ValidationCaseSensitive: validationCaseSensitive,
    RequireCharacterSpecial: requireCharacterSpecial,
    ForbidThreeNumbersSequential: forbidThreeNumbersSequential,
    QuantityCharactersAlpha: quantityCharactersAlpha,
    QuantityPasswordsDoNotRepeat: quantityPasswordsDoNotRepeat
  }),

  watch: {
    stringValue(v) {
      this.handleValidatePassword(v);
    }
  },

  async created() {
    const { data } = await getRulesPassword();

    this.passwordValidations = data;

    this.validationsCountTotal = this.passwordValidations.length;
  },

  methods: {
    handleValidatePassword(v) {
      this.validationsCount = 0;
      this.validationsStatus = [];

      if (v === undefined || v === null || v.length === 0) return false;

      this.passwordValidations.map((item, i) => {
        if (!this[item.nameParam](this.stringValue, parseInt(item.valueParam))) {
          item.id = i;

          this.validationsStatus.push({ id: i, valid: true });

          this.validationsCount++;
        } else {
          item.id = i;

          this.validationsStatus.push({ id: i, valid: false });
        }
      });

      if (this.validationsStatus.filter(item => item.valid === false).length === 0) this.$emit('validatePassword', true);
      else this.$emit('validatePassword', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.force-validation {
  display: flex;
  flex-direction: column;
  transition: all ease 0.1s;

  .force-validation__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 14px;

    .force-validation {
      display: block;
      width: 26px;
      height: 6px;
      background: var(--v-error-base);
      margin-right: 10px;
      border-radius: 6px;
      transition: all ease 0.1s;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background: var(--v-success-base);
      }
    }
  }

  .force-validation__messages {
    width: 100%;
    font-size: 0.75em;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-weight: 500;
    transition: all ease 0.1s;

    &.force-validation__message--error {
      color: var(--v-error-base);
    }

    &.force-validation__message--success {
      color: var(--v-success-base);
    }

    .v-icon {
      font-size: 1.5em;
      margin-right: 6px;
    }
  }
}
</style>
